//check to see if the top of the object is past the viewport
// this method is faster and async compared to getBoundingClientRect()
export function buildThresholdList(numSteps) {
    let thresholds = [];

    for (let i = 1.0; i <= numSteps; i++) {
        let ratio = i / numSteps;
        thresholds.push(ratio);
    }

    thresholds.push(0);
    return thresholds;
}


export function isIntersecting(targetWatchAttribute, targetModifyAttribute) {
    const target = document.querySelector(targetWatchAttribute);
    const targetModify = document.querySelector(targetModifyAttribute);
    if (!target || !targetModify) {return}
    const options = {
        threshold: buildThresholdList(3)
    }
    const callback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio == 0) {
                targetModify.classList.remove('is-intersecting');
                targetModify.classList.add('not-intersecting');
            }
            else {
                targetModify.classList.remove('not-intersecting');
                targetModify.classList.add('is-intersecting');
            }
        });
    };
    const observer = new IntersectionObserver(callback, options);

    
    observer.observe(target);
}